import request from '@/utils/request'

/**
 * 获取字典数据管理列表
 */
export const getDictDatatList = (data) => {
    return request({
        url: '/dict/data/lists',
        params: data
    })
}

/**
 * 选项列表
 */
export const getDictDataOptions = (data) => {
    return request({
        url: '/dict/data/option/lists',
        params: data
    })
}

/**
 * 获取字典列表
 */
export const getDictDataOptionsList = (code) => {
    return request({
        url: `/dict/data/code/${code}`
    })
}

/**
 * 添加
 */
export const addDictData = (data) => {
    return request({
        url: '/dict/data/manage',
        method: 'POST',
        data
    })
}

/**
 * 字典数据-详情
 */
export const getDictDataDetail = (id) => {
    return request({
        url: `/dict/data/${id}`
    })
}

/**
 * 字典数据-修改
 */
export const putDictData = (data) => {
    return request({
        url: '/dict/data/manage',
        method: 'PUT',
        data
    })
}

/**
 * 字典数据-删除
 */
export const delDictData = (id) => {
    return request({
        url: `/dict/data/${id}`,
        method: 'DELETE'
    })
}
/**
 * 字典数据-设置默认
 */
export const defaultDictData = (id) => {
    return request({
        url: `/dict/data/default/${id}`,
        method: 'POST'
    })
}

/**
 * 字典数据-移除默认
 */
export const defaultDelDictData = (id) => {
    return request({
        url: `/dict/data/default/${id}`,
        method: 'DELETE'
    })
}

/**
 * 导入
 */
export const importsDictData = (data) => {
    return request({
        url: '/dict/data/excel/imports',
        method: 'POST',
        data
    })
}

/**
 * 下载导入模板
 */
export const downloadDictData = () => {
    return request({
        url: '/department/excel/imports',
        method: 'GET'
    })
}
// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/dict/data/managee',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/dict/data/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/dict/data/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
